import React, { useState } from 'react';
import './Contact.css';
import CTASection from '../components/CTASection';

function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    tradeShows: '10-20',
    budget: '$50-$100k'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for contacting us! We will get back to you soon.');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="hero-overlay">
          <div className="hero-content">
            <p className="hero-tagline">Zibit helps your team plan smarter, execute better, and prove results.</p>
            <h1>Let's talk trade shows.</h1>
            <button className="cta-button">Get Started</button>
          </div>
        </div>
      </section>

      <section className="contact-content">
        <div className="content-container">
          <h2>Contact Us</h2>
          <p className="contact-intro">
            Cut the time you spend managing trade shows in half. Tell us about your team and 
            we'll show you how Zibit can transform your process.
          </p>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name*</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  placeholder="Jane"
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name*</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  placeholder="Smith"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email*</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="jane@company.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="company">Company*</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
                placeholder="Acme Corp"
              />
            </div>

            <div className="form-group-radio">
              <label className="radio-group-label">How many trade shows do you manage annually?</label>
              <div className="radio-group">
                {['1-5', '5-10', '10-20', '20+'].map(option => (
                  <label key={option} className="radio-label">
                    <input
                      type="radio"
                      name="tradeShows"
                      value={option}
                      checked={formData.tradeShows === option}
                      onChange={handleChange}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="form-group-radio">
              <label className="radio-group-label">What is your annual trade show budget?</label>
              <div className="radio-group">
                {['Under $50k', '$50-$100k', '$101k-$250k', '$250k+'].map(option => (
                  <label key={option} className="radio-label">
                    <input
                      type="radio"
                      name="budget"
                      value={option}
                      checked={formData.budget === option}
                      onChange={handleChange}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </div>

            <button type="submit" className="submit-button">Let's Zibit!</button>
          </form>
        </div>
      </section>

      <CTASection />
    </div>
  );
}

export default Contact;